export interface BabylonSceneSource {
    rootUrl: string;
    sceneFilename: string;
    pluginExtension?: string;
}

export function getBabylonSceneSource(url: string, defaultExtension?: string): BabylonSceneSource {
    const normalizedUrl = (url || '').trim();

    if (!normalizedUrl) {
        return {
            rootUrl: '',
            sceneFilename: '',
        };
    }

    const lastSlashIndex = normalizedUrl.lastIndexOf('/');
    const sceneFilename = lastSlashIndex >= 0 ? normalizedUrl.slice(lastSlashIndex + 1) : normalizedUrl;
    const rootUrl = lastSlashIndex >= 0 ? normalizedUrl.slice(0, lastSlashIndex + 1) : '';
    const extensionSource = sceneFilename.split(/[?#]/, 1)[0].toLowerCase();
    const extensionMatch = extensionSource.match(/\.[^.]+$/);
    const pluginExtension = extensionMatch?.[0] ?? defaultExtension;

    return {
        rootUrl,
        sceneFilename,
        pluginExtension,
    };
}